<template>
  <div class="position-relative" style="display: inline-flex">
    <button
      data-tour="notifications-btn"
      class="d-flex align-center"
      style="
        gap: 8px;
        background: #ffffff;
        border: 1px solid #bfbfbf;
        border-radius: 200px;
        padding: 8px 16px;
        cursor: pointer;
      "
      @click="handleOpenNotifications"
    >
      <img :src="megaphoneIcon" alt="" style="width: 17px; height: 18px; display: block" />
      <span
        style="
          font-family: Arial, sans-serif;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: #000000;
          white-space: nowrap;
        "
      >
        Announcements
      </span>
    </button>
    <div
      v-if="notificationStore.hasUnread"
      class="position-absolute d-flex align-center justify-center"
      style="width: 20px; height: 20px; border-radius: 50%; background-color: #cc2f2f; top: -8px; right: -8px"
    >
      <span
        style="font-family: Arial, sans-serif; font-weight: 700; font-size: 11px; line-height: 11px; color: #ffffff"
      >
        {{ notificationStore.unreadCount }}
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useNotificationStore } from '@/stores/notifications';
import { DataLayerMixin } from '../../mixins/dataLayerMixin';
import megaphoneIcon from '@/assets/icons/announcements-megaphone.png';

export default defineComponent({
  mixins: [DataLayerMixin],
  setup() {
    const notificationStore = useNotificationStore();
    return { notificationStore, megaphoneIcon };
  },
  methods: {
    handleOpenNotifications() {
      this.asuoDataLayerClick('accelerateDashboard', '31');
      this.notificationStore.openPanel();
    }
  }
});
</script>
